export default __webpack_public_path__ + "static/media/background_top.47af2133.svg";